// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content_23DFu","darkSide":"App_darkSide_sUvE9","alert":"App_alert_13ZWj","alertMargin":"App_alertMargin_SVJB2","noPadding":"App_noPadding__pKRi"};